import { EigenschaftFilterAuswahl, EigenschaftFilterAuswahlBereichsauswahl, EigenschaftFilterAuswahlUntergruppe, UiNormblatt, UiNormblattUebersicht, UntergruppeEigenschaftName } from "@/lib/models/globalerFilter";
import { BereichsauswahlOption, Eigenschaft, Wert } from "@/lib/models/globalerFilterApi";
import { environment, localization } from "@/lib/resources";
import { replaceHash } from "@/lib/util";
import $ from "jquery";

const globalerFilterData = environment.globalerFilterData!;

(() => {
	const $globalerFilter = $("#globaler-filter");

	if ($globalerFilter.length === 0) {
		return;
	}

	const $filterLink = $globalerFilter.find("div.overlay__header");
	const $filterZuruecksetzen = $globalerFilter.find("a.product-filter__clear");
	const $untergruppen = $globalerFilter.find("[data-ug-name]");
	const $untergruppenCheckboxes = $globalerFilter.find(".accordion .toggle__unit :checkbox");
	const $untergruppenSelect = $globalerFilter.find(".accordion .toggle__unit select");
	const $bereichsauswahlCheckbox = $globalerFilter.find("[data-bereichsauswahl-checkbox]");
	const $hauptFilterBereich = $globalerFilter.find("fieldset.globaler-filter-hauptfilter");

	const normblattUebersichten = getNormblattUebersichten();
	const normblattClass = environment.inocon ? "grid__entry" : "product-group-index__unit";
	const normblattClassHidden = "is-hidden";

	let aktuellerFilter = getAktuellerFilterFromHash();
	let aktuellerFilterQuery: string;

	// Beim Aufrufen der Seite werden alles Eigenschaften mit Bereichsauswahl auf Exaktes filtern gesetzt
	bereichsauswahlEigenschaftenZuruecksetzen();

	if (aktuellerFilter.length > 0) {
		//ggf. wurden nich alle Eigenschaften aus dem Hash Code ausgelsen, da ungültig
		//daher den Hash-Code mit dem eingelesenen Filter neu bilden.
		aktuellerFilterQuery = getFilterQueryFromAktuellerFilter();
		//Neuer Hash setzen ohne dabei Browser History eingräge zu produzieren.
		replaceHash(aktuellerFilterQuery);

		normblaetterFiltern();
		aktuellerFilterAuswahlInFilterControlsUebernehmen();
	}

	$globalerFilter.find(":checkbox,select")
		.on("change", filter);

	// Wenn die Bereichsauswahl aktiviert/deaktiviert wird, wird hier die passende Combobox
	// und das passende Label dazu angezeigt, bzw ausgebelendet.
	$bereichsauswahlCheckbox.on("change", e => {
		let checkbox = e.currentTarget as HTMLInputElement;

		let praefix = $(checkbox).attr("data-name-praefix") as string;
		let eigenschaftName = $(checkbox).attr("data-name-eigenschaft") as string;
		if (checkbox.checked) {
			bereichsauswahlVonBisAnzeigen(praefix, eigenschaftName);
		} else {
			bereichsauswahlExaktAnzeigen(praefix, eigenschaftName);
		}
	});

	$filterZuruecksetzen.on("click", () => {
		resetFilterClasses();
		resetFilter();
		$hauptFilterBereich.toggle(true);
	});

	function resetFilter() {
		$globalerFilter.find(":checkbox").prop("checked", false);
		$globalerFilter.find("select").val("");

		bereichsauswahlEigenschaftenZuruecksetzen();
		filter();
		return false;
	}

	function resetFilterClasses() {
		$untergruppen.addClass("is-closed");
		$untergruppen.removeAttr("data-global-filter-subgroup-selected");
	}

	$globalerFilter.find("form").on("submit", (e) => {
		//Form-Post Request verhindern
		e.preventDefault();

		$globalerFilter.find(".overlay__header").removeClass("is-active");
		$globalerFilter.find(".overlay__content").removeClass("is-visible");
	});

	$untergruppen.on("click", (e) => {
		$untergruppen.not(`[data-ug-name="${$(e.currentTarget).attr("data-ug-name")}"]`).addClass("is-closed");
		$untergruppen.not(`[data-ug-name="${$(e.currentTarget).attr("data-ug-name")}"]`)
			.removeAttr("data-global-filter-subgroup-selected");

		if (!$(e.currentTarget).attr("data-global-filter-subgroup-selected")) {
			// Wird eine Untergruppe ausgewählt, so soll der Filter zurückgesetzt werden,
			// außerdem wird der Hauptfilter ausgeblendet.
			// Klingt benutzerunfreundlich, ist auch so.
			// Wunsch Stefan Ganter
			resetFilter();
			$(e.currentTarget).attr("data-global-filter-subgroup-selected", "true");
			$hauptFilterBereich.toggle(false);
		} else {
			$(e.currentTarget).removeAttr("data-global-filter-subgroup-selected");
			$hauptFilterBereich.toggle(true);
		}

		// Beim schließen der Untergruppe werden alle gesetzten Filter für diese zurückgesetzt
		for (let untergruppe of $untergruppen.toArray()) {
			for (let eigenschaft of $globalerFilter.find("[data-name-eigenschaft]").toArray()) {
				let $eigenschaft = $(eigenschaft);
				if ($(untergruppe).data("ug-name") + "_" === $eigenschaft.data("name-praefix")) {
					bereichsauswahlExaktAnzeigen($eigenschaft.data("name-praefix"), $eigenschaft.data("name-eigenschaft"));
				}
			}
		}

		//Beim Wechseln der Untergruppen werden alle bisherigen Untergruppen-Eigenschaften zurückgesetzt
		$untergruppenCheckboxes.prop("checked", false);
		$untergruppenSelect.val("");

		filter();
	});

	// Zeigt die Combobox und das Label für die Bereichsfilterung an
	function bereichsauswahlVonBisAnzeigen(praefix: string, eigenschaftName: string) {
		// Checkbox
		$globalerFilter.find(`input[name="${praefix}${eigenschaftName}-bereichsauswahl"]`).prop("checked", true);
		// Label
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-genau"]`).hide();
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-vonbis"]`).show();
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-min-label"]`).text(localization("GlobalerFilterMin"));
		// Combobox
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-max"]`).show();
	}

	// Zeigt die Combobox und das Label für die Exakte filterung an
	function bereichsauswahlExaktAnzeigen(praefix: string, eigenschaftName: string) {
		// Label
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-genau"]`).show();
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-vonbis"]`).hide();
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-min-label"]`).text(localization("GlobalerFilterGenau"));
		// Combobox
		$globalerFilter.find(`[name="${praefix}${eigenschaftName}-max"]`).hide().val("");
	}

	function getNormblattUebersichten(): UiNormblattUebersicht[] {
		return $('[data-uebersicht="true"]')
			.toArray()
			.map(getUebersicht);

		function getUebersicht(element: HTMLElement): UiNormblattUebersicht {
			let normblaetter = $(element).find("[data-normblatt-guid]")
				.toArray()
				.map(getNormblatt);

			return {
				uebersicht: $(element),
				normblaetter: normblaetter,
				ueberschrift: $(element).prev("h2.product-group-index__grouping"),
			};
		}

		function getNormblatt(element: HTMLElement): UiNormblatt {
			let $element = $(element);

			return {
				normblatt: $element,
				normblattGuid: $element.attr("data-normblatt-guid") as string,
				gueltigeFilterKombinationen: $element.attr("data-gueltige-filter") as string,
				istKimNorm: normblattUebersichtItemIstKimNorm($element),
				normblattLinks: getNormblattLinks($element),
				normblattUrl: getNormblattUrl($element),
			};
		}
	}

	function getNormblattUrl($norm: JQuery<HTMLElement>): string | undefined {
		if (normblattUebersichtItemIstKimNorm($norm)) {
			return undefined;
		}

		return $($norm).find("a").first().attr("href");
	}

	function getNormblattLinks($norm: JQuery<HTMLElement>): JQuery<HTMLAnchorElement> | undefined {
		if (normblattUebersichtItemIstKimNorm($norm)) {
			return undefined;
		}

		return $($norm).find("a");
	}

	function normblattUebersichtItemIstKimNorm($norm: JQuery<HTMLElement>): boolean {
		return $($norm).attr("data-kim-norm") == "true";
	}

	function filter() {
		aktuellerFilter = [];
		for (let eigenschaft of globalerFilterData.Eigenschaften) {

			let eigenschaftFilterAuswahl = getEigenschaftFilterAuswahl(eigenschaft);
			if (eigenschaftFilterAuswahl !== null) {
				aktuellerFilter.push(eigenschaftFilterAuswahl);
			}
		};

		//Untergruppe
		// Da re-lounge's Handler für Untergruppen nach unserem die is-closed-Eigenschaft toggelt, kommen hier inkonsistente Werte an.
		// Diese werden mit dem Attribut "data-global-filter-subgroup-selected" abgefangen.
		let ausgewaehlteUntergruppe = $untergruppen.filter('[data-global-filter-subgroup-selected="true"]');

		if (ausgewaehlteUntergruppe.length === 1) {
			aktuellerFilter.push({
				Name: UntergruppeEigenschaftName,
				Bereichsauswahl: false,
				Werte: [ausgewaehlteUntergruppe.attr("data-ug-name") as string],
			});
		}


		aktuellerFilterQuery = getFilterQueryFromAktuellerFilter();
		//Neuer Hash setzen ohne dabei Browser History eingräge zu produzieren.
		replaceHash(aktuellerFilterQuery);

		normblaetterFiltern();
	}

	function normblaetterFiltern() {
		let anzahlNormblaetter = 0;
		let anzahlGueltigeNormblaetter = 0;

		if (aktuellerFilter.length === 0) {
			for (let normblattUebersicht of normblattUebersichten) {
				let normblattIndex = 0;

				for (let normblatt of normblattUebersicht.normblaetter) {
					normblattIndex++;
					let normblattBisherAusgeblendet = normblatt.normblatt.hasClass(normblattClassHidden);
					normblatt.normblatt.attr("class", normblattClass)
						.addClass(getNormblattGridCssClasses(normblattIndex));

					if (!normblatt.istKimNorm) {
						normblatt.normblattLinks!.attr("href", normblatt.normblattUrl!);
					}

					if (normblattBisherAusgeblendet) {
						initSlickSlider(normblatt.normblatt);
					}
				}

				normblattUebersicht.ueberschrift.show();
			}
			$filterLink.attr("style", "");
			$filterLink.text($filterLink.attr("data-gf-filtern")!);
			// Zum Ein- und Ausblenden des "Filterung aufheben"-Buttons benötgt re-lounge hier diese Klasse wenn gefiltert wird.
			// Wenn nicht gefiltert ist, soll die Klasse wieder entfernt werden.(A: 20972)
			$globalerFilter.removeClass("is-filtered");

			hideFilterResultCount();
		}
		else {
			for (let normblattUebersicht of normblattUebersichten) {
				let gueltigeNormblaetterVorhanden = false;
				let normblattIndex = 0;

				for (let normblatt of normblattUebersicht.normblaetter) {
					anzahlNormblaetter = anzahlNormblaetter + 1;

					if (gueltigesNormblatt(normblatt)) {
						if (!normblatt.istKimNorm) {
							//Filter Query an Normblatt-Url anhängen
							let normblattUrl = normblatt.normblattUrl!;
							if (normblattUrl.indexOf("?") > -1) {
								normblattUrl = normblattUrl + "&" + aktuellerFilterQuery;
							} else {
								normblattUrl = normblattUrl + "?" + aktuellerFilterQuery;
							}

							normblatt.normblattLinks!.attr("href", normblattUrl);
						}

						gueltigeNormblaetterVorhanden = true;
						anzahlGueltigeNormblaetter++;
						normblattIndex++;
						let normblattBisherAusgeblendet = normblatt.normblatt.hasClass(normblattClassHidden);

						normblatt.normblatt.attr("class", normblattClass)
							.addClass(getNormblattGridCssClasses(normblattIndex));

						if (normblattBisherAusgeblendet) {
							initSlickSlider(normblatt.normblatt);
						}
					} else {
						normblatt.normblatt.attr("class", normblattClass)
							.addClass(normblattClassHidden);
					}
				}

				normblattUebersicht.ueberschrift.toggle(gueltigeNormblaetterVorhanden);
			}

			$filterLink.attr("style", "color: #009827;");
			$filterLink.text($filterLink.attr("data-gf-gefiltert") + " (" + anzahlGueltigeNormblaetter + "/" + anzahlNormblaetter + ")");
			// Zum Ein- und Ausblenden des "Filterung aufheben"-Buttons benötgt re-lounge hier diese Klasse wenn gefiltert wird. (A: 20972)
			$globalerFilter.addClass("is-filtered");

			setFilterResultCount(anzahlGueltigeNormblaetter);
		}
	}

	function setFilterResultCount(anzahlNormblaetter: number) {
		let $filterResultElement = $(".results__value");
		if ($filterResultElement !== undefined && $filterResultElement !== null && $filterResultElement.length > 0) {
			$($filterResultElement[0]!).show();
			$(".filter_results_value_count").text(anzahlNormblaetter);
		}
	}

	function hideFilterResultCount() {
		let $filterResultElement = $(".results__value");
		if ($filterResultElement !== undefined && $filterResultElement !== null && $filterResultElement.length > 0) {
			$($filterResultElement[0]!).hide();
		}
	}

	function getEigenschaftFilterAuswahl(eigenschaft: Eigenschaft): EigenschaftFilterAuswahl | null {

		if (eigenschaft.Bereichsauswahl) {
			let min = getEigenschaftFilterAuswahlMin(eigenschaft.Name);
			let max = getEigenschaftFilterAuswahlMax(eigenschaft.Name);
			let werte = getEigenschaftFilterAuswahlWerte(eigenschaft.Name, true);

			if (min === null && max === null && werte === null) {
				return null;
			}

			return {
				Name: eigenschaft.Name,
				Bereichsauswahl: true,
				Min: min,
				Max: max,
				BereichsauswahlCheckbox: werte,
				BereichsauswahlOption: eigenschaft.BereichsauswahlOption,
				NamePraefix: getSelectedEigenschaftFilterNamePraefix(eigenschaft.Name, true)
			};
		}

		let werte = getEigenschaftFilterAuswahlWerte(eigenschaft.Name, false);

		if (werte === null) {
			return null;
		}

		return {
			Name: eigenschaft.Name,
			Bereichsauswahl: false,
			Werte: werte,
			NamePraefix: getSelectedEigenschaftFilterNamePraefix(eigenschaft.Name, false)
		};
	}

	function getSelectedEigenschaftFilterNamePraefix(eigenschaftName: string, bereichsauswahl: boolean): string | undefined {
		let praefix: string | undefined;

		let selector = bereichsauswahl ? `input[name="${eigenschaftName}-bereichsauswahl"]` : `input[name="${eigenschaftName}"]`;
		for (let element of $globalerFilter.find(selector).toArray()) {
			let attr = $(element).attr("data-name-praefix");
			if (attr) {
				praefix = attr;
			}
		}

		return praefix;
	}

	function getEigenschaftFilterAuswahlWerte(eigenschaftName: string, bereichsauswahl: boolean): string[] | null {
		let selector = bereichsauswahl ? `input[name="${eigenschaftName}-bereichsauswahl"]:checked` : `input[name="${eigenschaftName}"]:checked`;
		let werte = $globalerFilter.find<HTMLInputElement>(selector)
			.toArray()
			.flatMap(e => $(e).val() as string);

		return werte.length > 0 ? werte : null;
	}

	function getEigenschaftFilterAuswahlMin(eigenschaftName: string): number | null {
		let minValue = $globalerFilter.find(`select[name="${eigenschaftName}-min"]`).val() as string | undefined;

		if (minValue == "" || minValue == "---" || minValue == null) {
			return null;
		}

		let minValueParsed = parseFloat(minValue);

		return minValueParsed;
	}

	function getEigenschaftFilterAuswahlMax(eigenschaftName: string): number | null {
		let maxValue = $globalerFilter.find(`select[name="${eigenschaftName}-max"]`).val() as string | undefined;

		if (maxValue == "" || maxValue == "---" || maxValue == null) {
			return null;
		}

		let maxValueParsed = parseFloat(maxValue);

		return maxValueParsed;
	}

	function gueltigesNormblatt(normblatt: UiNormblatt): boolean {
		if (normblatt === null || !normblatt.gueltigeFilterKombinationen) {
			return false;
		}
		if (aktuellerFilter.some(f => f.Bereichsauswahl == true && f.Max != null && f.Max! < f.Min!)) {
			return false;
		}

		// Beispiel: normblatt.gueltigeFilterKombinationen = "d1:2;d2:3;h:2.40|d1:3;d2:4;h:4.40|d1:5;d2:6;h:10.70"
		let keyValueObjArray = getKeyValueObjArray(normblatt.gueltigeFilterKombinationen.split("|"));
		if (!CheckGueltigerBereichTemperatur(aktuellerFilter, keyValueObjArray)) {
			return false;
		}
		// Jede einzelne Kombination des Normblattes muss durgegangen werden
		for (let keyValueObj of keyValueObjArray) {
			let gueltig = true;

			for (let eigenschaft of aktuellerFilter) {
				let eigenschaftName = getEigenschaftName(eigenschaft);

				if (keyValueObj.hasOwnProperty(eigenschaftName)) {
					let eigenschaftWerte = keyValueObj[eigenschaftName]!.replace(",", ".").split(";");
					if (eigenschaft.Bereichsauswahl) {
						for (let wert of eigenschaftWerte) {
							gueltig = gueltigerBereich(eigenschaft, wert);
						}
					}
					else {
						// Mindestens ein Wert muss übereinstimmen damit die Norm gültig ist
						gueltig = false;
						for (let globalerFilterWert of eigenschaft.Werte) {
							for (let eigenschaftWert of eigenschaftWerte) {
								let wert: Wert;
								let filterWert: Wert;
								// Der Untergruppenfilter ist momentan (23.07.19) der einzige Filter der Stringwerte besitzt
								if (eigenschaftName == UntergruppeEigenschaftName) {
									wert = eigenschaftWert;
									filterWert = globalerFilterWert;
								} else {
									wert = parseFloat(eigenschaftWert);
									filterWert = parseFloat(globalerFilterWert as string);
								}

								if (wert == filterWert) {
									gueltig = true;
								}
							}
						}
					}
				} else {
					// Wenn die Filtereigenschaft auf der Norm nicht vorhanden ist, ist die Norm nicht gültig
					gueltig = false;
				}

				if (!gueltig) {
					break;
				}
			}

			if (gueltig) return true;
		}

		return false;
	}

	function getKeyValueObjArray(filterKombinationen: string[]) {
		// filterKombinationen = ["d1:2;d2:3;h:2.40", "d1:3;d2:4;h:4.40", "d1:5;d2:6;h:10.70"]
		return filterKombinationen.map(getKeyValueObj);
	}

	function getKeyValueObj(filterKombination: string): { [key: string]: string; } {
		// filterKombination = "d1:2;d2:3;h:2.40"
		let eigenschaften = filterKombination.split(";");
		// eigenschaften = ["d1:2", "d2:3", "h:2.40"]

		let keyValueObj: { [key: string]: string; } = {};
		// Jede Eigenschaft der Kombination wird durchgegangen und an das Objekt angefügt
		for (let i = 0; i < eigenschaften.length; i++) {
			// this = "d1:2"
			let keyValuePair = eigenschaften[i]!.split(":");
			// keyValuePair = ["d1", "2"]
			if (keyValueObj.hasOwnProperty(keyValuePair[0]!)) {
				keyValueObj[keyValuePair[0]!] += ";" + keyValuePair[1];
			} else {
				keyValueObj[keyValuePair[0]!] = keyValuePair[1]!;
			}
			// keyValueObj = {
			// mat: 2;3
			// d1: 2
			// d2: 3
			// h: 2.40 }
		}

		return keyValueObj;
	}

	function gueltigerBereich(filterEigenschaften: EigenschaftFilterAuswahlBereichsauswahl, normblattEigenschaftWert: string) {
		if (normblattEigenschaftWert === null) {
			return false;
		}

		let wert = parseFloat(normblattEigenschaftWert);
		let filterMin = filterEigenschaften.Min;
		let filterMax = filterEigenschaften.Max;

		return filterEigenschaften.BereichsauswahlCheckbox !== null
			? offeneBereichsAuswahlGueltig() || geschlosseneBereichsAuswahlGueltig()
			: wertAuswahlGueltig();

		function wertAuswahlGueltig(): boolean {
			return filterEigenschaften.Min === null || wert === filterMin!;
		}

		function offeneBereichsAuswahlGueltig(): boolean {
			return filterEigenschaften.Min === null && filterEigenschaften.Max === null // kein Filter
				|| filterEigenschaften.Min === null && wert <= filterMax!
				|| filterEigenschaften.Max === null && wert >= filterEigenschaften.Min!;
		}

		function geschlosseneBereichsAuswahlGueltig(): boolean {
			if (filterEigenschaften.BereichsauswahlOption === BereichsauswahlOption.AuswahlNachUntenUeberschreiten) {
				return wert >= filterMin! && wert >= filterMax!;
			}

			return wert >= filterMin! && wert <= filterMax!;
		}
	}

	// Setzt im Filter die Werte, die im Link ausgelesen wurden
	function aktuellerFilterAuswahlInFilterControlsUebernehmen() {
		for (let eigenschaft of aktuellerFilter) {
			if (eigenschaft.Name === UntergruppeEigenschaftName) {
				let untergruppeEigenschaft = eigenschaft as EigenschaftFilterAuswahlUntergruppe;
				if (untergruppeEigenschaft.Werte.length === 1) {
					let vorselektierteUntergruppe = $globalerFilter.find(`[data-ug-name="${untergruppeEigenschaft.Werte[0]}"]`);
					vorselektierteUntergruppe.removeClass("is-closed");
					vorselektierteUntergruppe.attr("data-global-filter-subgroup-selected", "true");
				}
				continue;
			}

			if (!eigenschaft.Bereichsauswahl) {
				for (let wert of eigenschaft.Werte) {
					$globalerFilter.find(`#${eigenschaft.Name}-${wert}`)
						.prop("checked", true);
				}
				continue;
			}

			if (eigenschaft.BereichsauswahlCheckbox == null) {
				$globalerFilter.find(`select[name="${eigenschaft.Name}-min"]`).val(eigenschaft.Min!);
				bereichsauswahlExaktAnzeigen("", eigenschaft.Name);
				continue;
			}

			if (eigenschaft.Min !== null) {
				$globalerFilter.find(`select[name="${eigenschaft.Name}-min"]`).val(eigenschaft.Min);
			}

			if (eigenschaft.Max !== null) {
				$globalerFilter.find(`select[name="${eigenschaft.Name}-max"]`).val(eigenschaft.Max);
			}
			bereichsauswahlVonBisAnzeigen("", eigenschaft.Name);
		};
	}

	//Liefert die Url bzw. Hash für den aktuellen Filter
	function getFilterQueryFromAktuellerFilter() {
		if (aktuellerFilter.length === 0) {
			return "";
		}

		let hash = "";

		for (let filterWert of aktuellerFilter) {
			if (hash.length > 0) {
				hash += "&";
			}

			if (filterWert.Bereichsauswahl) {
				if (filterWert.BereichsauswahlCheckbox === null) {
					if (filterWert.Min !== null) {
						hash += "gf-" + filterWert.Name + "-min" + "=" + filterWert.Min;
					}
				} else {
					hash += "gf-" + filterWert.Name + "-rs" + "=" + filterWert.BereichsauswahlCheckbox[0];
					if (filterWert.Min !== null && filterWert.Max) {
						hash += "&" + "gf-" + filterWert.Name + "-min" + "=" + filterWert.Min + "&" +
							"gf-" + filterWert.Name + "-max" + "=" + filterWert.Max;
					} else {
						if (filterWert.Min !== null) {
							hash += "&" + "gf-" + filterWert.Name + "-min" + "=" + filterWert.Min;
						}

						if (filterWert.Max) {
							hash += "&" + "gf-" + filterWert.Name + "-max" + "=" + filterWert.Max;
						}
					}
				}
			}
			else {
				hash += "gf-" + filterWert.Name + "=" + filterWert.Werte.join(";");
			}
		}

		return hash;
	}

	//Liest den aktuellen Filter über die Url bzw. Hash ein.
	function getAktuellerFilterFromHash(): EigenschaftFilterAuswahl[] {
		if (window.location.hash === "" || window.location.hash.indexOf("?") === 0) {
			return [];
		}

		let filterValues = window.location.hash.substring(1).split("&");
		let filter: EigenschaftFilterAuswahl[] = [];

		//Für das Einlesen des Filters werden die Eigenschaften der JSON Datenquelle verwendet
		//und nur Eigenschaften die in dieser Auflistung bekannt sind eingelesen.
		for (let eigenschaft of globalerFilterData.Eigenschaften) {
			if (eigenschaft.Bereichsauswahl) {
				let filterValueMin: any = getFilterValue(filterValues, eigenschaft.Name, "-min");
				if (filterValueMin !== null) {
					filterValueMin = parseFloat(filterValueMin);
				}
				let filterValueMax: any = getFilterValue(filterValues, eigenschaft.Name, "-max");
				if (filterValueMax !== null) {
					filterValueMax = parseFloat(filterValueMax);
				}
				let filterValueBereichsauswahlcheckbox = getFilterValue(filterValues, eigenschaft.Name, "-rs");
				if (filterValueBereichsauswahlcheckbox !== null) {
					if (filterValueMin !== null || filterValueMax !== null || filterValueBereichsauswahlcheckbox !== null) {
						filter.push({
							Name: eigenschaft.Name,
							Bereichsauswahl: true,
							Min: filterValueMin,
							Max: filterValueMax,
							BereichsauswahlCheckbox: filterValueBereichsauswahlcheckbox,
						});
					}
				} else {
					if (filterValueMin !== null) {
						filter.push({
							Name: eigenschaft.Name,
							Bereichsauswahl: true,
							Min: filterValueMin,
							Max: filterValueMax,
							BereichsauswahlCheckbox: null,
						});
					}
				}
			}
			else {
				let filterValue = getFilterValue(filterValues, eigenschaft.Name, null);

				if (filterValue !== null) {
					filter.push({
						Name: eigenschaft.Name,
						Bereichsauswahl: false,
						Werte: filterValue.split(";"),
					});
				}
			}
		}

		//Untergruppe separat überprüfen
		//Dies ist eine "virtuelle" Eigenschaft und nicht in der globalerFilterData.Eigenschaften Auflistung enthalten
		let filterValue = getFilterValue(filterValues, UntergruppeEigenschaftName, null);

		if (filterValue !== null) {
			let ugValue = filterValue.split(";");

			if (ugValue.length === 1) {
				for (let item of filter) {
					// Eine Änderung an der Präfix-Logik für Untergruppen muss auch im View GlobalerFilter.vbhtml nachgezogen werden.
					item.NamePraefix = ugValue[0] + "_";
				}
			}

			filter.push({
				Name: UntergruppeEigenschaftName,
				Bereichsauswahl: false,
				Werte: ugValue
			});
		}

		return filter;
	}

	function getFilterValue(filterValues: string[], eigenschaftName: string, eigenschaftNameZusatz: string | null): string | null {
		eigenschaftName = "gf-" + eigenschaftName;
		if (eigenschaftNameZusatz !== null) {
			eigenschaftName = eigenschaftName + eigenschaftNameZusatz;
		}
		eigenschaftName = eigenschaftName + "=";

		let filterValue = filterValues.filter((filterValue) => filterValue.indexOf(eigenschaftName) == 0);

		if (filterValue.length === 1) {
			return filterValue[0]!.substring(eigenschaftName.length);
		}
		else {
			return null;
		}
	}

	//Erzeugt die Grid Css Klassen für die View-Ports s, m. l, xl
	//Bei Änderungen auch Models.Produkte.Normblaetter.GetGridCssClasses() berücksichtigen
	function getNormblattGridCssClasses(normblattPosition: number) {
		return getNormblattGridCssClass(normblattPosition, "s", 2) + " " +
			getNormblattGridCssClass(normblattPosition, "m", 3) + " " +
			getNormblattGridCssClass(normblattPosition, "l", 4) + " " +
			getNormblattGridCssClass(normblattPosition, "xl", 5);
	}

	function getNormblattGridCssClass(normblattPosition: number, cssClassName: string, modulo: number) {
		let value = normblattPosition % modulo;

		if (value === 0) {
			value = modulo;
		}

		return cssClassName + value.toString();
	}

	function bereichsauswahlEigenschaftenZuruecksetzen() {
		// Setzt alle Filtereigenschaften wieder auf die Exakte filterung zurück
		for (let eigenschaft of globalerFilterData.Eigenschaften) {
			bereichsauswahlExaktAnzeigen("", eigenschaft.Name);
		}
	}
})();

function getEigenschaftName(eigenschaft: EigenschaftFilterAuswahl) {
	if (typeof eigenschaft.NamePraefix == "string" && eigenschaft.NamePraefix.length > 0) {
		return eigenschaft.Name.replace(eigenschaft.NamePraefix, "");
	}

	return eigenschaft.Name;
}

// Nach vorgaben von re-lounge: Damit wird die Größe des Sliders kalkuliert. Das muss passieren NACHDEM das Element sichtbar ist.
function initSlickSlider(container: JQuery<HTMLElement>) {
	if (typeof $.fn.slick == "function") {
		container.find('.slick-slider').slick('slickSetOption', 'dots', true, true);
	}
}

function CheckGueltigerBereichTemperatur(aktuellerFilter: EigenschaftFilterAuswahl[], keyValueObjArray: { [key: string]: string; }[]) {
	let aktuelleBereichsauswahlEigenschaften = aktuellerFilter.filter(a => a.Bereichsauswahl == true
		&& a.BereichsauswahlOption == BereichsauswahlOption.WertebereichEinsatztemperatur);

	for (let eigenschaft of aktuelleBereichsauswahlEigenschaften) {
		eigenschaft = eigenschaft as EigenschaftFilterAuswahlBereichsauswahl;
		let eigenschaftName = getEigenschaftName(eigenschaft);

		// werte => min und max Werte vom Normblatt abhängig der Eigenschaft
		let werte = [...new Set(keyValueObjArray.map(o => o[eigenschaftName]))].sort();
		if (werte.length != 2) {
			console.error(`Eigenschaft ${eigenschaftName} mit WertebereichEinsatztemperatur hat ungültige Menge an Werten: [${werte}]`);
			break;
		}

		let minValueNormblatt = parseFloat(werte[0]!);
		let maxValueNormblatt = parseFloat(werte[1]!);

		if (eigenschaft.Max != null) {
			// Zuerst prüfen ob noch alles im Min-Bereich vom Normblatt liegt und danach prüfen ob es im Max-Bereich liegt
			if ((minValueNormblatt > eigenschaft.Min! || minValueNormblatt >= eigenschaft.Max!)
				|| (maxValueNormblatt < eigenschaft.Max! || maxValueNormblatt <= eigenschaft.Min!)) {
				return false;
			}
		}
	}
	return true;
}

